import { cn } from "@/lib/utils";
import { CheckCircleIcon, MessageSquareIcon, XCircleIcon } from "lucide-react";
import { ClientContentBlocks } from "@/components/common/content-blocks/client-content-blocks";
import { hasCommentContent } from "../quiz-service";

const VARIANT_CONFIG: Record<
  "bad" | "good" | "comment",
  {
    icon: typeof XCircleIcon;
    container: string;
    iconColor: string;
    border: string;
    titleText: string;
  }
> = {
  bad: {
    icon: XCircleIcon,
    container: "from-red-50",
    iconColor: "text-red-600",
    border: "border-red-200",
    titleText: "text-red-900",
  },
  good: {
    icon: CheckCircleIcon,
    container: "from-green-50",
    iconColor: "text-green-600",
    border: "border-green-200",
    titleText: "text-green-900",
  },
  comment: {
    icon: MessageSquareIcon,
    container: "from-blue-50",
    iconColor: "text-blue-600",
    border: "border-blue-200",
    titleText: "text-blue-900",
  },
};

export const QuizCalloutBlock = ({
  contentBlocks,
  title,
  variant,
}: {
  contentBlocks: ContentBlock[];
  title: string;
  variant: "bad" | "good" | "comment";
}) => {
  const config = VARIANT_CONFIG[variant];
  const Icon = config.icon;
  const isEmpty = !hasCommentContent(contentBlocks);

  return (
    <div
      className={cn(
        "my-4 flex flex-col gap-4 rounded-xl border p-4 sm:p-4",
        "bg-gradient-to-br to-white",
        config.container,
        config.border,
      )}
    >
      <div
        className={cn(
          "flex items-center gap-3",
          isEmpty ? "" : cn("border-b pb-4", config.border),
        )}
      >
        <span className={cn("font-semibold", config.titleText)}>{title}</span>
      </div>

      {!isEmpty && (
        <div className={"[&_p:last-child]:mb-0"}>
          <ClientContentBlocks blocks={contentBlocks} theme={"quiz_comment"} />
        </div>
      )}
    </div>
  );
};
